import {
  Dialogs,
  type DialogRegistryEntry,
  type DialogRegistryOptions,
} from './types'

// Account
import ChangeNameDialog from './account/ChangeNameDialog.vue'
import ChangeEmailDialog from './account/ChangeEmailDialog.vue'
import ChangePasswordDialog from './account/ChangePasswordDialog.vue'
import ChangeUsernameDialog from './account/ChangeUsernameDialog.vue'
import ChangeTitleDialog from './account/ChangeTitleDialog.vue'
import ChangeBioDialog from './account/ChangeBioDialog.vue'
import ChangeCompanyNameDialog from './account/ChangeCompanyNameDialog.vue'
import DeactivateAccountDialog from './account/DeactivateAccountDialog.vue'
import DeactivateAccountPromptDialog from './account/DeactivateAccountPromptDialog.vue'
import DeleteAccountDialog from './account/DeleteAccountDialog.vue'
import ConfirmDeactivateAccountDialog from './account/ConfirmDeactivateAccountDialog.vue'
import ConfirmDeleteAccountDialog from './account/ConfirmDeleteAccountDialog.vue'
import UploadProfilePictureDialog from './account/UploadProfilePictureDialog.vue'
import ConfirmProfilePictureDialog from './account/ConfirmProfilePictureDialog.vue'

// File
import FileAccessDialog from './file/FileAccessDialog.vue'
import FileSettingsDialog from './file/FileSettingsDialog.vue'
import FilePrivacySettingsDialog from './file/FilePrivacySettingsDialog.vue'
import FileOwnersDialog from './file/FileOwnersDialog.vue'
import FileAuthorsDialog from './file/FileAuthorsDialog.vue'
import ShareDialog from './file/ShareDialog.vue'
import DownloadDialog from './file/DownloadDialog.vue'
import ProcessingDownloadDialog from './file/ProcessingDownloadDialog.vue'
import AddFolderDialog from './file/AddFolderDialog.vue'
import RenameFolderDialog from './file/RenameFolderDialog.vue'
import MoveItemsDialog from './file/MoveItemsDialog.vue'
import ConfirmMoveDialog from './file/ConfirmMoveDialog.vue'
import DeleteFoldersDialog from './file/DeleteFoldersDialog.vue'
import CannotDeleteFolderDialog from './file/CannotDeleteFolderDialog.vue'
import ArchiveFilesDialog from './file/ArchiveFilesDialog.vue'
import ConfirmArchiveFilesDialog from './file/ConfirmArchiveFilesDialog.vue'
import MakeFilesPrivateDialog from './file/MakeFilesPrivateDialog.vue'
import MakeFilesPublicDialog from './file/MakeFilesPublicDialog.vue'
import UpdateFilePrivacyDialog from './file/UpdateFilePrivacyDialog.vue'
import DefaultFilePrivacyDialog from './file/DefaultFilePrivacyDialog.vue'
import RemoveFileAccessDialog from './file/RemoveFileAccessDialog.vue'
import RemoveFileOwnerDialog from './file/RemoveFileOwnerDialog.vue'
import RemoveFileAuthorDialog from './file/RemoveFileAuthorDialog.vue'
import ManageAccessTipDialog from './file/ManageAccessTipDialog.vue'
import SelectFolderDialog from './file/SelectFolderDialog.vue'
import FileActionsDialog from './file/FileActionsDialog.vue'
import FolderActionsDialog from './file/FolderActionsDialog.vue'
import ThreeDotsMenuDialog from './file/ThreeDotsMenuDialog.vue'
import ArchiveMenuDialog from './file/ArchiveMenuDialog.vue'
import CopyrightInfoDialog from './file/CopyrightInfoDialog.vue'
import FolderInfoDialog from './file/FolderInfoDialog.vue'

// Copyright
import CopyrightOwnersDialog from './copyright/CopyrightOwnersDialog.vue'
import NewCopyrightOwnerDialog from './copyright/NewCopyrightOwnerDialog.vue'
import EditCopyrightOwnerDialog from './copyright/EditCopyrightOwnerDialog.vue'
import DeleteCopyrightOwnerDialog from './copyright/DeleteCopyrightOwnerDialog.vue'
import SelectCopyrightDialog from './copyright/SelectCopyrightDialog.vue'
import AddNewCopyrightDialog from './copyright/AddNewCopyrightDialog.vue'
import AllOwnersDialog from './copyright/AllOwnersDialog.vue'
import AllAuthorsDialog from './copyright/AllAuthorsDialog.vue'
import OwnersAuthorsTipDialog from './copyright/OwnersAuthorsTipDialog.vue'
import CopyrightPageTipDialog from './copyright/CopyrightPageTipDialog.vue'

// Billing
import PayDialog from './billing/PayDialog.vue'
import PayCreditsDialog from './billing/PayCreditsDialog.vue'
import CancelSubscriptionDialog from './billing/CancelSubscriptionDialog.vue'
import ConfirmCancelSubscriptionDialog from './billing/ConfirmCancelSubscriptionDialog.vue'
import ResubscribeDialog from './billing/ResubscribeDialog.vue'
import ResubscribeIAPDialog from './billing/ResubscribeIAPDialog.vue'
import IAPDialog from './billing/IAPDialog.vue'
import CantPayDialog from './billing/CantPayDialog.vue'
import ConfirmPaymentMethodDialog from './billing/ConfirmPaymentMethodDialog.vue'
import UpdatePaymentMethodDialog from './billing/UpdatePaymentMethodDialog.vue'
import SelectPlanBillingDialog from './billing/SelectPlanBillingDialog.vue'
import PlanDetailsDialog from './billing/PlanDetailsDialog.vue'
import UpcomingBillingDetailsDialog from './billing/UpcomingBillingDetailsDialog.vue'
import BuyReportCreditsDialog from './billing/BuyReportCreditsDialog.vue'

// Upload
import UploadDetailsDialog from './upload/UploadDetailsDialog.vue'
import ConfirmUploadDialog from './upload/ConfirmUploadDialog.vue'
import ConfirmUploadDetailsDialog from './upload/ConfirmUploadDetailsDialog.vue'
import CancelUploadDialog from './upload/CancelUploadDialog.vue'
import PreUploadPrivacyDialog from './upload/PreUploadPrivacyDialog.vue'
import OriginalCreatorDialog from './upload/OriginalCreatorDialog.vue'
import FirstProUploadDialog from './upload/FirstProUploadDialog.vue'
import UploadTipDialog from './upload/UploadTipDialog.vue'

// Infringement
import InfringementReportDialog from './infringement/InfringementReportDialog.vue'
import InfringementMatchesDialog from './infringement/InfringementMatchesDialog.vue'
import CreateReportDialog from './infringement/CreateReportDialog.vue'
import MatchPairDialog from '@/features/infringement/components/MatchPairDialog.vue'
import ShareReportDialog from './infringement/ShareReportDialog.vue'

// Upgrade
import UpgradeToProDialog from './upgrade/UpgradeToProDialog.vue'
import UpgradeBundleLimitDialog from './upgrade/UpgradeBundleLimitDialog.vue'
import UpsellDialog from './upgrade/UpsellDialog.vue'

// Misc
import ErrorDialog from './misc/ErrorDialog.vue'
import SuccessDialog from './misc/SuccessDialog.vue'
import UpdatedTermsDialog from './misc/UpdatedTermsDialog.vue'
import WelcomeBackDialog from './misc/WelcomeBackDialog.vue'
import WelcomeToDacrProDialog from './misc/WelcomeToDacrProDialog.vue'
import FromInviteDialog from './misc/FromInviteDialog.vue'
import AddOriginsDialog from './misc/AddOriginsDialog.vue'
import RegistrationsDialog from './misc/RegistrationsDialog.vue'
import ReportFeedbackDialog from './misc/ReportFeedbackDialog.vue'
import TransactionHistoryDialog from './misc/TransactionHistoryDialog.vue'
import NotificationMenuDialog from './misc/NotificationMenuDialog.vue'

const registry = new Map<Dialogs, DialogRegistryEntry>()

const register = (
  name: Dialogs,
  component: DialogRegistryEntry['component'],
  options: DialogRegistryOptions = {}
) => {
  registry.set(name, { component, ...options })
}

const modalDialog = {
  presentation: 'modal',
} satisfies DialogRegistryOptions

const viewportSlideup = {
  slideup: { height: 'viewport' },
} satisfies DialogRegistryOptions

// Account
register(Dialogs.ChangeName, ChangeNameDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ChangeEmail, ChangeEmailDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ChangePassword, ChangePasswordDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ChangeUsername, ChangeUsernameDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ChangeTitle, ChangeTitleDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ChangeBio, ChangeBioDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ChangeCompanyName, ChangeCompanyNameDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.DeactivateAccount, DeactivateAccountDialog, viewportSlideup)
register(
  Dialogs.DeactivateAccountPrompt,
  DeactivateAccountPromptDialog,
  viewportSlideup
)
register(Dialogs.DeleteAccount, DeleteAccountDialog, viewportSlideup)
register(Dialogs.ConfirmDeactivateAccount, ConfirmDeactivateAccountDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ConfirmDeleteAccount, ConfirmDeleteAccountDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.UploadProfilePicture, UploadProfilePictureDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ConfirmProfilePicture, ConfirmProfilePictureDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})

// File
register(Dialogs.FileAccess, FileAccessDialog, viewportSlideup)
register(Dialogs.FileSettings, FileSettingsDialog, viewportSlideup)
register(
  Dialogs.FilePrivacySettings,
  FilePrivacySettingsDialog,
  viewportSlideup
)
register(Dialogs.FileOwners, FileOwnersDialog, viewportSlideup)
register(Dialogs.FileAuthors, FileAuthorsDialog, viewportSlideup)
register(Dialogs.Share, ShareDialog, viewportSlideup)
register(Dialogs.Download, DownloadDialog, modalDialog)
register(Dialogs.ProcessingDownload, ProcessingDownloadDialog, {
  presentation: 'modal',
  modal: { class: 'max-w-[300px]!' },
})
register(Dialogs.AddFolder, AddFolderDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.RenameFolder, RenameFolderDialog, viewportSlideup)
register(Dialogs.MoveItems, MoveItemsDialog, viewportSlideup)
register(Dialogs.ConfirmMove, ConfirmMoveDialog, modalDialog)
register(Dialogs.DeleteFolders, DeleteFoldersDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.CannotDeleteFolder, CannotDeleteFolderDialog, {
  presentation: 'modal',
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ArchiveFiles, ArchiveFilesDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ConfirmArchiveFiles, ConfirmArchiveFilesDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.MakeFilesPrivate, MakeFilesPrivateDialog, modalDialog)
register(Dialogs.MakeFilesPublic, MakeFilesPublicDialog, modalDialog)
register(Dialogs.UpdateFilePrivacy, UpdateFilePrivacyDialog, viewportSlideup)
register(Dialogs.DefaultFilePrivacy, DefaultFilePrivacyDialog, viewportSlideup)
register(Dialogs.RemoveFileAccess, RemoveFileAccessDialog, modalDialog)
register(Dialogs.RemoveFileOwner, RemoveFileOwnerDialog, modalDialog)
register(Dialogs.RemoveFileAuthor, RemoveFileAuthorDialog, modalDialog)
register(Dialogs.ManageAccessTip, ManageAccessTipDialog, {
  presentation: 'modal',
  modal: { class: 'overflow-hidden p-0! tablet-h:p-0!' },
})
register(Dialogs.SelectFolder, SelectFolderDialog, viewportSlideup)
register(Dialogs.FileActions, FileActionsDialog)
register(Dialogs.FolderActions, FolderActionsDialog)
register(Dialogs.CopyrightInfo, CopyrightInfoDialog, viewportSlideup)
register(Dialogs.FolderInfo, FolderInfoDialog, viewportSlideup)
register(Dialogs.ThreeDotsMenu, ThreeDotsMenuDialog)
register(Dialogs.ArchiveMenu, ArchiveMenuDialog)

// Copyright
register(Dialogs.CopyrightOwners, CopyrightOwnersDialog, viewportSlideup)
register(Dialogs.NewCopyrightOwner, NewCopyrightOwnerDialog, viewportSlideup)
register(Dialogs.EditCopyrightOwner, EditCopyrightOwnerDialog, viewportSlideup)
register(Dialogs.DeleteCopyrightOwner, DeleteCopyrightOwnerDialog, modalDialog)
register(Dialogs.SelectCopyright, SelectCopyrightDialog, viewportSlideup)
register(Dialogs.AddNewCopyright, AddNewCopyrightDialog, viewportSlideup)
register(Dialogs.AllOwners, AllOwnersDialog)
register(Dialogs.AllAuthors, AllAuthorsDialog)
register(Dialogs.OwnersAuthorsTip, OwnersAuthorsTipDialog, {
  presentation: 'modal',
  modal: { class: 'overflow-hidden p-0! tablet-h:p-0!' },
})
register(Dialogs.CopyrightPageTip, CopyrightPageTipDialog, {
  presentation: 'modal',
  modal: { class: 'overflow-hidden p-0! tablet-h:p-0!' },
})

// Billing
register(Dialogs.Pay, PayDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[400px]!' },
})
register(Dialogs.PayCredits, PayCreditsDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.CancelSubscription, CancelSubscriptionDialog, viewportSlideup)
register(Dialogs.ConfirmCancelSubscription, ConfirmCancelSubscriptionDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.Resubscribe, ResubscribeDialog)
register(Dialogs.ResubscribeIAP, ResubscribeIAPDialog)
register(Dialogs.IAP, IAPDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.CantPay, CantPayDialog, viewportSlideup)
register(Dialogs.ConfirmPaymentMethod, ConfirmPaymentMethodDialog)
register(Dialogs.UpdatePaymentMethod, UpdatePaymentMethodDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.SelectPlanBilling, SelectPlanBillingDialog, {
  modal: { class: 'tablet-h:max-w-[546px]! tablet-h:items-center' },
})
register(Dialogs.PlanDetails, PlanDetailsDialog, viewportSlideup)
register(
  Dialogs.UpcomingBillingDetails,
  UpcomingBillingDetailsDialog,
  viewportSlideup
)
register(Dialogs.BuyReportCredits, BuyReportCreditsDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})

// Upload
register(Dialogs.UploadDetails, UploadDetailsDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-v:max-w-[600px]!' },
})
register(Dialogs.ConfirmUpload, ConfirmUploadDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.ConfirmUploadDetails, ConfirmUploadDetailsDialog, {
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.CancelUpload, CancelUploadDialog)
register(Dialogs.PreUploadPrivacy, PreUploadPrivacyDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.OriginalCreator, OriginalCreatorDialog)
register(Dialogs.FirstProUpload, FirstProUploadDialog, modalDialog)
register(Dialogs.UploadTip, UploadTipDialog, {
  presentation: 'modal',
  modal: { class: 'overflow-hidden p-0! tablet-h:p-0!' },
})

// Infringement
register(Dialogs.InfringementReport, InfringementReportDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.InfringementMatches, InfringementMatchesDialog)
register(Dialogs.CreateReport, CreateReportDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.MatchPair, MatchPairDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[1300px]!' },
})
register(Dialogs.ShareReport, ShareReportDialog, modalDialog)

// Upgrade
register(Dialogs.UpgradeToPro, UpgradeToProDialog, {
  modal: {
    class:
      'tablet-h:max-w-[500px]! bg-gradient-to-b from-green-100 from-10% to-white to-60% border-2 border-green-900/50 rounded-xl!',
  },
  slideup: {
    height: 'viewport',
    class:
      'bg-gradient-to-b from-green-100 from-10% to-white to-60% border-2 border-green-900/50',
  },
})
register(Dialogs.UpgradeBundleLimit, UpgradeBundleLimitDialog, {
  modal: {
    class:
      'tablet-h:max-w-[500px]! bg-gradient-to-b from-green-100 from-10% to-white to-60% border-2 border-green-900/50 rounded-xl!',
  },
  slideup: {
    height: 'viewport',
    class:
      'bg-gradient-to-b from-green-100 from-10% to-white to-60% border-2 border-green-900/50',
  },
})
register(Dialogs.Upsell, UpsellDialog, {
  modal: {
    class:
      'tablet-h:max-w-[360px]! bg-gradient-to-b from-green-100 from-10% to-white to-60% border-2 border-green-900/50 rounded-xl!',
  },
})

// Misc
register(Dialogs.Error, ErrorDialog, modalDialog)
register(Dialogs.Success, SuccessDialog, {
  ...modalDialog,
  modal: { class: 'tablet-h:max-w-[400px]!' },
})
register(Dialogs.UpdatedTerms, UpdatedTermsDialog)
register(Dialogs.WelcomeBack, WelcomeBackDialog, {
  presentation: 'modal',
  modal: { class: 'tablet-h:max-w-[500px]! overflow-hidden' },
})
register(Dialogs.WelcomeToDacrPro, WelcomeToDacrProDialog, {
  presentation: 'modal',
  modal: {
    class:
      'max-w-[382px]! tablet-h:max-w-[500px]! overflow-hidden bg-gradient-to-b from-green-100 from-15% to-white',
  },
})
register(Dialogs.FromInvite, FromInviteDialog, {
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.AddOrigins, AddOriginsDialog, {
  modal: { class: 'tablet-h:max-w-[700px]!' },
})
register(Dialogs.Registrations, RegistrationsDialog)
register(Dialogs.ReportFeedback, ReportFeedbackDialog, {
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.TransactionHistory, TransactionHistoryDialog, {
  ...viewportSlideup,
  modal: { class: 'tablet-h:max-w-[500px]!' },
})
register(Dialogs.NotificationMenu, NotificationMenuDialog)

export function resolveDialog(
  name: Dialogs
): DialogRegistryEntry['component'] | undefined {
  return registry.get(name)?.component
}

export function resolveDialogOptions(name: Dialogs): DialogRegistryOptions {
  return registry.get(name) ?? {}
}

export { registry }
